import './Home.scss';
import anyKey from './images/any-key.gif';
import mike from './images/mike.jpg';
import homerStick from './images/stick.gif';

export const Home = () => {
	return (
		<>
			<div className='welcome panel'>
				<h1>Welcome to Code Investigator</h1>
				<p>I have some useful utils like base64 JavaScript encoding.</p>
				<p>Try out the different menu items in the top.</p>
				<p>
					Remember to watch my{' '}
					<a href='https://www.youtube.com/channel/UCxWCnBPnLrCBsMg-0TWTzpQ'>
						videos about tech and programming
					</a>
					... On YouTube! :-)
				</p>
				<p>Have a nice day!</p>
			</div>
			<div className='welcome madeby panel'>
				<div className='picture__text'>
					<h2>Influencer</h2>
					<p>Mike Møller Nielsen</p>
					<p>Your mentor and fullstack developer :-)</p>
					<p>
						Follow me on{' '}
						<a href='https://twitter.com/MikeMllerNiels2'>Twitter</a>
					</p>
					<p>
						Support me on{' '}
						<a href='https://www.patreon.com/mikemoellernielsen'>Patreon</a>
					</p>
				</div>
				<div className='pic-item'>
					<img src={anyKey} alt='Home Simpson Any Key' />
				</div>
				<div className='picture'>
					<div className='pic-item-mike'>
						<img src={mike} width='150px' alt='Mike' />
					</div>
				</div>
				<div className='pic-item'>
					<img src={homerStick} alt='Homer with stick' />
				</div>
			</div>
			<div className='admin-interface'>
				<a
					onClick={() => {}}
					href='https://www.youtube.com/watch?v=dQw4w9WgXcQ'
				>
					Admin interface
				</a>
			</div>
		</>
	);
};
